import insertBreakOpportunities from '@/components/general/FieldNameConvert';
import { breakRegex } from '@/configs/constants';
import { OptionOtherItem } from '@/types/option';
import { cn } from '@/utils/utils';
import { ReactNode } from 'react';

export interface OptionCompProps {
    title?: string,
    data?: OptionOtherItem[],
    textDecoration?: string,
    descriptionList?: string[],
    specialNote?: string[],
    isSameSize?: boolean,
    contentComp?: ReactNode,
    hash?: string
}
const OptionComp = ({ option }: { option: OptionCompProps }) => {
    const { title, textDecoration, data = [], descriptionList = [], specialNote = [], isSameSize = false, contentComp, hash } = option;

    return (
        <div id={hash} className='leading-[calc(30/14)] w-full'>
            <div className={cn(
                (textDecoration || descriptionList.length > 0) && 'mb-5'
            )}
            >
                {
                    textDecoration && (
                        <div className='flex items-center gap-1'>
                            <div className='size-3 bg-customOrange '></div>
                            <p className='font-semibold'>{textDecoration}</p>
                        </div>
                    )
                }
                {
                    descriptionList.length > 0 &&
                    descriptionList.map((des, idx) => (
                        <p key={idx}>{des}</p>
                    ))

                }
            </div>
            {
                title && (
                    <div className='flex items-center justify-center bg-customOrange xsm:h-[50px] h-[40px]'>
                        <p className='font-bold text-white'>
                            {title}
                        </p>
                    </div>
                )
            }

            {
                data?.map((item, index) => {
                    return (
                        <div
                            key={item.fieldName + index}
                            className={cn(
                                'grid sm:grid-cols-5 grid-cols-2 items-center border-x border-b border-border-gray2',
                                isSameSize && 'xsm:grid-cols-2',
                                index === 0 && 'border-t'
                            )}
                        >
                            <div
                                className={cn(
                                    'common-item sm:col-span-2 col-span-1 flex flex-wrap items-center justify-end text-right font-medium bg-[#F8F7F1] border-r border-border-gray2 h-full',
                                    isSameSize && 'col-span-1',
                                    breakRegex.test(item.fieldName) && 'break-on-wbr',
                                    item?.fieldNameClass
                                )}
                            >
                                <p>{breakRegex.test(item.fieldName) ? insertBreakOpportunities({ text: item.fieldName }) : item.fieldName}</p>

                            </div>
                            <div className={cn(
                                'common-item sm:col-span-3 col-span-1 flex items-center justify-center text-center',
                                isSameSize && 'col-span-1',
                                item?.valueClass
                            )}
                            >
                                {item.value}
                            </div>
                        </div>
                    );
                })
            }
            {
                contentComp
            }

            <div className='text-fs-mid12 xsm:text-fs-mid13 xsm:leading-[24px] leading-[20px] mt-[10px] flex flex-col items-center justify-center text-center text-black-6'>
                {
                    specialNote?.length > 0 && (
                        specialNote.map((note, idx) => (
                            <p key={idx}>{note}</p>
                        ))
                    )
                }
            </div>
        </div>
    );
};

export { OptionComp };
